export var SerieTypeEnum;
(function (SerieTypeEnum) {
    SerieTypeEnum["arearange"] = "arearange";
    SerieTypeEnum["column"] = "column";
    SerieTypeEnum["line"] = "line";
})(SerieTypeEnum || (SerieTypeEnum = {}));
